import React from "react";
import Breadcrumb from "../../../components/breadcrumb";

function BuscarPartidoHeader() {
    return (
        <>
            <Breadcrumb
                items={[
                    { label: 'Inicio', to: '/' },
                    { label: 'Partidos', isCurrent: true },
                ]}
                className="mb-4"
            />

            <div className="flex flex-col gap-2 sm:gap-3 mb-4 sm:mb-6">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight border-l-4 border-red-500 pl-3 sm:pl-4">Partidos</h1>
                <p className="text-slate-400 text-base sm:text-lg font-medium max-w-2xl leading-relaxed">
                    Explorá el historial completo de encuentros, resultados y estadísticas detalladas del Club Atlético Aguada.
                </p>
            </div>
        </>
    );
}

export default BuscarPartidoHeader;
